/**
 * TEN BUT — Barra fixa de compra da PDP mobile (Story 16.4 → Story 21.5)
 *
 * Casca fina. Esta barra NÃO decide variante, NÃO calcula preço e NÃO fala com /cart/add.
 * Tudo isso já existe em `ten-but-product-main.liquid` e continua onde está:
 *   - grade de tamanho + `refreshSizes`   → única verdade sobre disponibilidade por cor
 *   - `updateCart` / `updatePrice`        → quem escreve estado, preço e urgência
 *   - interceptor de submit (13.17/21.5)  → AJAX /cart/add + os três sinais de confirmação
 *
 * ── A regra, desde 2026-09-22 (veredicto do dono na 21.1, linha 3) ──────────────────────
 *
 * A barra é SÓ o botão `Dodaj do koszyka`, e ele ramifica pela grade de cima — e só por ela:
 *
 *   produto com tamanho, NENHUM número activo na grade → abre o painel de compra (21.5);
 *   produto com tamanho, um número activo na grade    → adiciona direto, sem etapa;
 *   produto sem tamanho, disponível                   → adiciona direto, nunca abre painel;
 *   produto sem tamanho, indisponível                 → `disabled`.
 *
 * E, por cima das quatro (pedido do dono, 2026-09-23): produto JÁ no carrinho → abre o
 * painel sem tamanho escolhido, em vez de adicionar — nunca um segundo par por toque repetido.
 *
 * Nas palavras do dono: "isso só acontece se o tamanho não tiver selecionado".
 *
 * ⚠️ ISTO SUBSTITUI o pedido de 2026-07-23 (Story 16.4, commit 41702bf), que punha na barra
 * uma pílula de tamanho com um número JÁ escolhido (39, ou o mais próximo) e o botão activo.
 * Com um número sempre escolhido, o ramo "sem tamanho → abre o painel" nunca correria. NÃO
 * reponha o palpite: o veredicto de 2026-09-22 é posterior e explícito, e é ele que vale.
 * A lista própria que abria para cima (a outra correcção de 2026-07-23) saiu junto com a
 * pílula — a escolha de tamanho a meio da página passou a ser o painel.
 */
(function () {
  'use strict';

  var MQ_MOBILE = '(max-width: 989px)';

  var bar = document.querySelector('[data-tbp-sticky-atc]');
  // A âncora é o sentinela, não `#tb-add-to-cart`: o id não existe no terceiro ramo do CTA
  // (produto sem opção de tamanho E indisponível). Sem alvo, sem barra.
  var sentinel = document.querySelector('[data-tbp-atc-sentinel]');
  if (!bar || !sentinel) return;

  var addBtn = bar.querySelector('.tbp__sticky-add');
  var cta = document.getElementById('tb-add-to-cart'); // pode ser null (3º ramo do CTA)
  var grid = document.querySelector('.tbp__sizes--grid');

  var hasSizes = bar.hasAttribute('data-tbp-has-size');
  var addLabel = addBtn ? addBtn.getAttribute('data-add-label') || '' : '';
  var unavailableLabel = addBtn ? addBtn.getAttribute('data-unavailable-label') || '' : '';

  var mq = window.matchMedia(MQ_MOBILE);
  var visible = false;

  // ── Leitura da grade (a verdade) ─────────────────────────────────────────────

  function sizeButtons() {
    return grid ? Array.prototype.slice.call(grid.querySelectorAll('.tbp__size-btn')) : [];
  }

  // Story 19.1 (AC-B4): o esgotado passou de `disabled` para `aria-disabled` (para o clique
  // existir e ser medível). Um predicado só no site — o global vem do inline da PDP; o fallback
  // cobre a ordem de carga em qualquer cenário.
  function sizeUnavailable(btn) {
    if (typeof window.tbSizeUnavailable === 'function') return window.tbSizeUnavailable(btn);
    return !btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true'
      || btn.classList.contains('sold-out');
  }

  function hasAvailableSize() {
    return sizeButtons().some(function (btn) { return !sizeUnavailable(btn); });
  }

  // "Já escolheu" = um número `.active` na grade de cima (size-lock 13.8: nada vem
  // pré-seleccionado). Não a barra, não o painel, não a memória de sessão.
  function hasActiveSize() {
    return sizeButtons().some(function (btn) {
      return btn.classList.contains('active') && !sizeUnavailable(btn);
    });
  }

  // ── Estado do botão ──────────────────────────────────────────────────────────

  /**
   * Com tamanho: o botão está vivo enquanto a cor activa tiver algum número à venda — com
   * número escolhido adiciona, sem número abre o painel (AC-A4: nunca `disabled` por falta
   * de tamanho). Sem tamanho: o estado do CTA de cima é a única verdade.
   * Enquanto o botão mostra um sinal de compra ("Trwa dodawanie...", "Dodano"), quem manda
   * no rótulo é o interceptor; ele chama isto de novo quando o sinal acaba.
   */
  function mirror() {
    if (!addBtn || addBtn.hasAttribute('data-tb-add-state')) return;
    var ok = hasSizes ? hasAvailableSize() : !!(cta && !cta.disabled);
    var label = ok ? addLabel : unavailableLabel;
    // Escopo F (AC-F4): o texto vive no `.tb-cta-label`; escrever no botão apagava o ícone.
    var labelEl = addBtn.querySelector('.tb-cta-label') || addBtn;
    if (label && labelEl.textContent.trim() !== label) labelEl.textContent = label;
    addBtn.classList.toggle('tbp__cta--sold', !ok);
    addBtn.disabled = !ok;
  }

  // O inline da section chama isto ao final de `refreshSizes` (troca de cor) e quando um
  // sinal de compra termina.
  window.__tbpSyncStickySizes = mirror;

  if (cta) {
    // Produto sem opção de tamanho: aí sim o estado do CTA é a única verdade. `updateCart`
    // escreve textContent E disabled, então os dois precisam ser observados.
    new MutationObserver(function () { if (!hasSizes) mirror(); }).observe(cta, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  // ── O toque ──────────────────────────────────────────────────────────────────

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      // AC-C4: com um sinal no ar (em voo, ou o "Dodano" de 1,6 s) o toque não faz nada.
      if (addBtn.disabled || addBtn.hasAttribute('data-tb-add-state')) return;

      var needsSize = hasSizes && !hasActiveSize();
      // Pedido do dono, 2026-09-23: com o produto JÁ no carrinho, este botão não adiciona
      // outra vez — reabre o painel, sem tamanho escolhido, para ela escolher. Um segundo
      // toque sem querer deixava de pôr um segundo par. (O CTA de cima não muda.)
      var inCart = typeof window.__tbpInCart === 'function' && window.__tbpInCart();

      if (needsSize || inCart) {
        if (typeof window.__tbpOpenBuyPanel === 'function'
          && window.__tbpOpenBuyPanel(addBtn, { fresh: inCart })) return;
        // Painel por carregar: sem número, o CTA de cima faz o que já fazia (19.5) — leva-a
        // à grade. Com número, segue para adicionar.
        if (needsSize) {
          if (cta) cta.click();
          return;
        }
      }

      // Proxy puro: o submit do CTA real dispara o interceptor da 13.17/21.5. A rota diz ao
      // interceptor que o sinal 1 aparece AQUI, no botão que ela tocou.
      if (typeof window.__tbpAddFrom === 'function') window.__tbpAddFrom({ busy: addBtn });
      else if (cta && !cta.disabled) cta.click();
    });
  }

  // ── Gatilho ──────────────────────────────────────────────────────────────────

  function measure() {
    // A altura da barra vira folga no fim do documento, para a última linha do rodapé
    // não ficar coberta.
    document.documentElement.style.setProperty('--tbp-sticky-h', bar.offsetHeight + 'px');
  }

  function setVisible(on) {
    if (!mq.matches) on = false;
    if (on === visible) return;
    visible = on;
    bar.classList.toggle('tbp__sticky-atc--on', on);
    document.body.classList.toggle('tbp-sticky-on', on);
    if (on) {
      bar.removeAttribute('inert');
      measure();
      // A barra é o caminho para o painel: aparecer = hora de lhe aquecer as fotos.
      if (typeof window.__tbpWarmBuyPanel === 'function') window.__tbpWarmBuyPanel();
    } else {
      bar.setAttribute('inert', '');
    }
  }

  bar.setAttribute('inert', '');

  /**
   * "O CTA já saiu pelo topo?" — pede as duas condições de propósito: um elemento ainda
   * sem layout devolve um rect todo zerado, e só `bottom <= 0` leria isso como "passou",
   * abrindo a barra no topo da página. Com `top < 0` junto, o rect zerado dá false.
   */
  function passedUp(rect) {
    return rect.top < 0 && rect.bottom <= 0;
  }

  // Leitura pontual de layout — usada só no boot e em mudanças de viewport/breakpoint.
  // NUNCA em loop de scroll: a Story 14.3 removeu essas leituras de propósito.
  function evaluate() {
    setVisible(passedUp(sentinel.getBoundingClientRect()));
  }

  var io = new IntersectionObserver(function (entries) {
    var entry = entries[entries.length - 1];
    // Passou pra cima = barra entra; voltou ao viewport = barra sai. Simétrico nos dois
    // sentidos, inclusive sob momentum scroll.
    setVisible(!entry.isIntersecting && passedUp(entry.boundingClientRect));
  }, { threshold: 0 });
  io.observe(sentinel);

  var resizeRaf = 0;
  window.addEventListener('resize', function () {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(function () {
      resizeRaf = 0;
      if (visible) measure();
    });
  });

  function onBreakpoint() {
    if (mq.matches) evaluate();
    else setVisible(false);
  }
  if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onBreakpoint);
  else if (typeof mq.addListener === 'function') mq.addListener(onBreakpoint);

  // Boot: estado do botão a partir da grade e posição (a página pode abrir já rolada, por
  // restauração de scroll).
  mirror();
  evaluate();
})();
